import { Template } from "@/types";
import { Button } from "@/components/ui/button";
import { LayoutTemplate } from "lucide-react";
import TemplateListItem from "./TemplateListItem";
import { useTranslation } from "react-i18next";

interface TemplateListProps {
  templates: Template[];
  onPreviewClick?: (template: Template) => void;
}

const TemplateList = ({ templates, onPreviewClick }: TemplateListProps) => {
  const { t } = useTranslation();

  if (templates.length === 0) {
    return (
      <div className="text-center py-16 border-2 border-dashed border-gray-200 dark:border-slate-600 rounded-2xl bg-gray-50 dark:bg-slate-800/50">
        <div className="mx-auto h-16 w-16 bg-gradient-to-br from-blue-50 to-purple-50 dark:from-blue-900/30 dark:to-purple-900/30 rounded-full flex items-center justify-center mb-6 border border-blue-100 dark:border-blue-700">
          <LayoutTemplate size={28} className="text-blue-500 dark:text-blue-400" />
        </div>
        <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-slate-100">{t('templates.list.not_found_title')}</h3>
        <p className="text-gray-600 dark:text-slate-300 mb-6 max-w-md mx-auto">{t('templates.list.not_found_desc')}</p>
        <Button
          onClick={() => (window.location.href = "/templates/create")}
          className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-6 py-2 rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-200"
        >
          {t('templates.list.create_btn')}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4">
        {templates.map((template) => (
          <TemplateListItem
            key={template.id}
            template={template}
            onPreviewClick={onPreviewClick}
          />
        ))}
      </div>
    </div>
  );
};

export default TemplateList;
